import { Injectable, Inject } from '@angular/core';
import {  Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { catchError, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';


@Injectable({ providedIn: 'root' })
export class ProjectConfigurationService {

    currentConfigData;

    BACKEND_URL;
    PROJECT_NAME;

    clientId;

    constructor(@Inject('BACKEND_URL') BACKEND_URL, @Inject('PROJECT_NAME') PROJECT_NAME,
     private http: HttpClient, private router: Router, private matSnack: MatSnackBar) {
        this.BACKEND_URL = BACKEND_URL;
        this.PROJECT_NAME  = PROJECT_NAME;
    }


    public getConfigData(clientId?) {
        //var body = { instance_name: clientId };
        var body = { instance_name: (clientId ? clientId : this.PROJECT_NAME)};

        return this.http.post<any>(this.BACKEND_URL + '/config', body).pipe(
            map((result) => {
                if (result) {
                    this.currentConfigData = result;
                    this.currentConfigData.customer_id = result._id;
                    return result;
                }else{
                    this.matSnack.open("No fue posible ingresar al sistema. Revise la conexión", "close", { duration: 2000 });
                }
            }),
            catchError(this.handleError("No fue posible ingresar al sistema", undefined))
        )

    }

    /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // If there is not more items to administer

            // TODO: send the error to remote logging infrastructure
            console.error("Error:", + operation, error); // log to console instead

/*                 this.matSnack.open("Error : " + operation + " " + error.error  , 'cerrar', 
                { duration: 6000,  panelClass: ['blue-snackbar'] }) */           


            // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.

            return of(result as T);
        };
    }



}